// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5098":"9bf77b8c","5551":"81953b18"}[chunkId] + ".chunk.css";
};